import { render, staticRenderFns } from "./FoodTime.vue?vue&type=template&id=76298eb9&scoped=true&"
import script from "./FoodTime.vue?vue&type=script&lang=js&"
export * from "./FoodTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76298eb9",
  null
  
)

export default component.exports